export default function StartScreen({ onStart }) {
  return (
    <div className="screen">
      <h1 className="title">Welke AI training past bij jou?</h1>
      <div className="card">
        <div className="startcard">
          <p className="start-line">
            <span className="start-icon">📝</span>
            <span>
              Beantwoord 4 korte vragen en vind de opleiding of training die bij
              jou past.
            </span>
          </p>

          <p className="start-line">
            <span className="start-icon">🚀</span>
            <span>Je krijgt de antwoorden per direct te zien.</span>
          </p>
        </div>
        <button className="startbutton" onClick={onStart}>
          Start
        </button>
      </div>
      <div className="progress-divider" />
      <p>
        Liever zelf door onze AI trainingen browsen?{" "}
        <a href="https://www.beeckestijn.org/artificial-intelligence-trainingen/">
          Bekijk ons aanbod.
        </a>
      </p>
    </div>
  );
}
